"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveNativeScriptHash = void 0;
const errors_1 = require("../errors");
const internal_1 = require("../types/internal");
const public_1 = require("../types/public");
const utils_1 = require("../utils");
const getVersion_1 = require("./getVersion");
const nativeScript_1 = require("./serialization/nativeScript");
const send = (params) => (Object.assign({ ins: 18 }, params));
function* deriveScriptHash_startComplexScript(script) {
    yield send({
        p1: 1,
        p2: 0,
        data: (0, nativeScript_1.serializeComplexNativeScriptStart)(script),
        expectedResponseLength: 0,
    });
}
function* deriveNativeScriptHash_addSimpleScript(script) {
    yield send({
        p1: 2,
        p2: 0,
        data: (0, nativeScript_1.serializeSimpleNativeScript)(script),
        expectedResponseLength: 0,
    });
}
function isComplexScript(script) {
    switch (script.type) {
        case public_1.NativeScriptType.ALL:
        case public_1.NativeScriptType.ANY:
        case public_1.NativeScriptType.N_OF_K:
            return true;
        default:
            return false;
    }
}
function* deriveNativeScriptHash_addScript(script) {
    if (isComplexScript(script)) {
        yield* deriveScriptHash_startComplexScript(script);
        for (const subscript of script.params.scripts) {
            yield* deriveNativeScriptHash_addScript(subscript);
        }
    }
    else {
        return yield* deriveNativeScriptHash_addSimpleScript(script);
    }
}
function* deriveNativeScriptHash_finishWholeNativeScript(displayFormat) {
    const response = yield send({
        p1: 3,
        p2: 0,
        data: (0, nativeScript_1.serializeWholeNativeScriptFinish)(displayFormat),
        expectedResponseLength: internal_1.NATIVE_SCRIPT_HASH_LENGTH,
    });
    return {
        scriptHashHex: response.toString('hex'),
    };
}
function ensureScriptHashDerivationSupportedByAppVersion(version) {
    if (!(0, getVersion_1.getCompatibility)(version).supportsNativeScriptHashDerivation) {
        throw new errors_1.DeviceVersionUnsupported(`Native script hash derivation not supported by Ledger app version ${(0, utils_1.getVersionString)(version)}.`);
    }
}
function* deriveNativeScriptHash(version, script, displayFormat) {
    (0, getVersion_1.ensureLedgerAppVersionCompatible)(version);
    ensureScriptHashDerivationSupportedByAppVersion(version);
    yield* deriveNativeScriptHash_addScript(script);
    const { scriptHashHex } = yield* deriveNativeScriptHash_finishWholeNativeScript(displayFormat);
    return {
        scriptHashHex,
    };
}
exports.deriveNativeScriptHash = deriveNativeScriptHash;
//# sourceMappingURL=data:application/json;base64,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